import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { CreditPullTiersSettingsStore } from '../stores/creditPullTiersStore';

export const useCreditPullTiersSettingsStore = () =>
  useContext<{
    creditPullTiersStore: CreditPullTiersSettingsStore;
  }>(StoreContext);
